import { animate, state, style, transition, trigger } from '@angular/animations';
import { AfterViewInit, Component, DestroyRef, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { DataBagService } from 'src/app/common/data-bag.service';
import { ProductService } from '../product.service';
import { ProductRoomsAddComponent } from './product-rooms-add/product-rooms-add.component';
import { ProductRoomsEditComponent } from './product-rooms-edit/product-rooms-edit.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
	selector: 'app-product-rooms',
	templateUrl: './product-rooms.component.html',
	styleUrls: ['./product-rooms.component.css'],
	animations: [
		trigger('detailExpand', [
			state('collapsed', style({ height: '0px', overflow: 'hidden' })),
			state('expanded', style({ height: '*' })),
			transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
		]),
	],
})
export class ProductRoomsComponent implements OnInit, AfterViewInit {
	@Input() editable: boolean;
	@ViewChild('dataTable') table: MatTable<[]>;
	@ViewChild(MatSort) sort: MatSort;
	matData = new MatTableDataSource<any>();
	activeTab = 'list';
	editor = ClassicEditor;
	editorConfig = {
		toolbar: ['bold', 'italic', '|', 'bulletedList', 'numberedList'],
	};

	viewSet: Array<any> = [
		{ value: 'WM', name: 'Widok morze' },
		{ value: 'WG', name: 'Widok góry' },
		{ value: 'WMG', name: 'Widok morze i góry' },
		{ value: 'BW', name: 'Brak widoku' },
	];

	displayedColumns: string[] = [
		`lp`,
		`type`,
		'name',
		`roomName`,
		'level',
		`view`,
		`description`,
		`conveniances`,
		`isActive`,
		`NoName`,
		'edit',
	];

	columnsToDisplayWithExpand = [...this.displayedColumns, 'expand'];
	expandedElement: null;

	constructor(
		public service: ProductService,
		public bag: DataBagService,
		public dialog: MatDialog,
		private readonly destroyRef: DestroyRef,
	) {}

	ngOnInit(): void {
		this.bag.get('/product/room/type/?limit=999', (result, error) => {
			this.service.mockData.roomType = result.results;
		});
		this.matData.data = this.service.data.rooms;
		this.service.refreshRooms$
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe(() => (this.matData.data = this.service.data.rooms));
	}

	ngAfterViewInit() {
		this.matData.sort = this.sort;
	}

	refreshFilter(event: Event) {
		const filterValue = (event.target as HTMLInputElement).value;
		if (filterValue.length < 3 && filterValue.length > 0) {
			return;
		}

		this.matData.filter = filterValue.trim().toLowerCase();
	}

	getView(item) {
		const matchView = this.viewSet.find((findView) => findView.value === item);
		const returnedItem = matchView ? matchView.name : '';
		return returnedItem;
	}

	getConveniences(convenience) {
		const matchConvenience = this.service.mockData.convenience.find((findObj) => findObj.id === convenience);
		return matchConvenience ? matchConvenience.name : '';
	}

	onEditClick(element) {
		this.dialog
			.open(ProductRoomsEditComponent, { data: element })
			.afterClosed()
			.subscribe((result) => {
				this.service.data.rooms.map((room, index) => {
					if (room.id === result.id) {
						this.service.data.rooms[index] = result;
					}
				});
				this.table.renderRows();
			});
	}

	addRooms() {
		this.dialog
			.open(ProductRoomsAddComponent)
			.afterClosed()
			.subscribe((result) => {
				this.matData.data = this.service.data.rooms;
				this.table.renderRows();
			});
	}
}
